module.exports = __webpack_public_path__ + "static/img/from.9605cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/from.png
// module id = SKFY
// module chunks = 13